import { Capacitor } from "@capacitor/core";

export const usePlatform = () => {
    const isiOS = computed(() => Capacitor.getPlatform() === "ios");
    const isAndroid = computed(() => Capacitor.getPlatform() === "android");
    const isWeb = computed(() => Capacitor.getPlatform() === "web");
    const isMobilePlatform = computed(() => isiOS.value || isAndroid.value);

    return {
        isiOS,
        isAndroid,
        isWeb,
        isMobilePlatform,
    };
};
